'use client';

import { market } from '@utils/config';
import currencies from '@utils/currency/currencies';
import { gTagViewItem } from '@utils/googleTags';
import { useEffect } from 'react';
import { Variant } from '@ts/variant';
import { Product } from '@ts/product';

type Props = {
  variant?: Variant;
  product: Product;
};

export default function PDPGoogleTagManager(props: Props) {
  const { variant, product } = props;

  useEffect(() => {
    if (product) {
      gTagViewItem(variant, product, currencies[market]);
    }
  }, [variant, product]);

  return null;
}
